module.exports = __webpack_public_path__ + "assets/HKNova-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Regular.ttf
// module id = 110
// module chunks = 0